import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ImportantNotice() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-316">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-317">
        <div className="flex items-start gap-4 p-6 rounded-xl mb-10 shadow-sm" style={{
        backgroundColor: '#ffffff',
        borderLeft: '4px solid #c8a84b',
        borderTop: '1px solid #ede9e0',
        borderRight: '1px solid #ede9e0',
        borderBottom: '1px solid #ede9e0'
      }} data-id="element-318">
          <AlertTriangleIcon className="flex-shrink-0 mt-0.5" size={24} style={{
          color: '#c8a84b'
        }} data-id="element-319" />
          <div data-id="element-320">
            <h2 className="text-lg font-bold uppercase mb-1" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-321">
              Important Notice
            </h2>
            <p className="text-base font-medium" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-322">
              Broad head arrows are strictly prohibited on the course.
            </p>
          </div>
        </div>
      </div>
    </div>;
}